export default __webpack_public_path__ + "assets/images/dd75c694189f687dc93f396c04c7d0d2.svg";